if (!customElements.get('size-chart')) {
  class SizeChart extends HTMLElement {
    constructor() {
      super();
      this.pills = [];
      this.rows = [];
      this.genderPills = [];
      this.genderTargets = [];
      this.scrollEl = null;
      this.hintEl = null;
      this.resizeObserver = null;
      this.handleRegionClick = this.handleRegionClick.bind(this);
      this.handleGenderClick = this.handleGenderClick.bind(this);
      this.updateHint = this.updateHint.bind(this);
    }

    connectedCallback() {
      // Two independent pill groups can exist on the same page (one
      // `<size-chart>` instance per group in practice: the table wraps the
      // region pills, `measuring-guides.liquid` wraps the gender pills) —
      // each is queried/wired separately so pressing one never touches the
      // other's state.
      this.pills = [...this.querySelectorAll('[data-region]')];
      this.rows = [...this.querySelectorAll('[data-region-row]')];
      this.genderPills = [...this.querySelectorAll('[data-gender]')];
      this.genderTargets = [...this.querySelectorAll('[data-gender-target]')];
      this.scrollEl = this.querySelector('[data-size-chart-scroll]');
      this.hintEl = this.querySelector('[data-scroll-hint]');

      this.pills.forEach(pill => pill.addEventListener('click', this.handleRegionClick));
      this.genderPills.forEach(pill => pill.addEventListener('click', this.handleGenderClick));

      if (this.scrollEl && this.hintEl) {
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateHint);
          this.resizeObserver.observe(this.scrollEl);
        } else {
          window.addEventListener('resize', this.updateHint);
          requestAnimationFrame(this.updateHint);
        }
      }
    }

    disconnectedCallback() {
      this.pills.forEach(pill => pill.removeEventListener('click', this.handleRegionClick));
      this.genderPills.forEach(pill => pill.removeEventListener('click', this.handleGenderClick));
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateHint);
    }

    updateHint() {
      const hasOverflow = this.scrollEl.scrollWidth > this.scrollEl.clientWidth;
      this.hintEl.hidden = !hasOverflow;
    }

    activateRegion(pill) {
      const region = pill.dataset.region;

      this.pills.forEach(p => {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });

      this.rows.forEach(row => {
        row.hidden = row.dataset.regionRow !== region;
      });
    }

    activateGender(pill) {
      const gender = pill.dataset.gender;

      this.genderPills.forEach(p => {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });

      this.genderTargets.forEach(target => {
        target.hidden = target.dataset.genderTarget !== gender;
      });
    }

    handleRegionClick(event) {
      this.activateRegion(event.currentTarget);
    }

    handleGenderClick(event) {
      this.activateGender(event.currentTarget);
    }
  }

  customElements.define('size-chart', SizeChart);
}
